import React, { useState, useEffect } from "react"
import Typography from "@mui/material/Typography"
import { Button, Container, Box, Stack } from '@mui/material'
import { useCuestionario } from "../hooks/useCuestionario.js"
import { useNavigate } from "react-router-dom"
import { useUser } from "../hooks/useUser"
import { usePerfilEmpresarial } from "../hooks/usePerfilEmpresarial"
import { useMunicipios } from "../hooks/useMunicipios"
import { useTranslation } from 'react-i18next'
import { AutocompleteSearchRequired } from "../components/commons/AutocompleteSearchRequired.jsx"
import { useTools } from "../hooks/useTools.jsx"
import { ErrorMessage } from '../components/commons/ErrorMessage.jsx';
import { useForm } from "react-hook-form"
import { TextFieldRequired } from "../components/commons/TextFieldRequired.jsx"
import Parser from "html-react-parser";
import { useSecurity } from "../hooks/useSecurity"

export function CrearPerfilEmpresarial() {
    const { nuevoConPerfilEmpresarial, getCuestionarioActual } = useCuestionario()
    const { getData } = usePerfilEmpresarial()
    const { getMunicipios } = useMunicipios()
    const { user, isLogged } = useUser()
    const { isValidDNI, isValidCIF } = useTools()
    useSecurity();

    useEffect(() => {
        var cuestionarioActualPromise = getCuestionarioActual(user);
        cuestionarioActualPromise.then(
            (x) => {
                if (x) {
                    navigate("/MisCuestionarios");
                }
            },
            (y) => {
                console.error("Error: " + y);
            }
        );

    }, []);


    //TODO PASAR A CONTEXT y asi solo hay que pasarlo al componente hijo el control y setValue
    const {
        //Maneja los campos del form y sus estados
        control,
        //Maneja la presentacion del formulario
        handleSubmit,
        setValue,
        watch
    } = useForm({ mode: "onSubmit" });

    const [areFieldsDisabled, setAreFieldsDisabled] = useState(false);
    const selectedComunidad = watch("comunidadAutonoma");
    const selectedProvincia = watch("provincia");
    const selectedCnaePrincipal = watch("cnaePrincipal");
    const selectedCnaeDivision = watch("cnaeDivisiones");
    const selectedCnaeSecundaria = watch("cnaeSecundaria");

    //Dependencias de los distintos campos entre ellos (Disable y borrado de values )
    useEffect(() => {
        if (!selectedComunidad) {
            setValue("provincia", null);
            setValue("municipio", null);
        }

        if (!selectedProvincia) {
            setValue("municipio", null);
        }

        if (!selectedCnaePrincipal) {
            setValue("cnaeDivisiones", null);
        }

    }, [selectedComunidad, selectedProvincia, selectedCnaePrincipal, selectedCnaeDivision, selectedCnaeSecundaria, setValue]);

    const navigate = useNavigate()
    const { t } = useTranslation()

    const [openDialogError, setOpenDialogError] = useState(false);

    const [comunidadesAutonomasList, setComunidadesAutonomasList] = useState([])
    const [volumenNegocioList, setVolumenNegocioList] = useState([])
    const [cnaeList, setCnaeList] = useState([])
    const [cnaeDivisionesList, setCnaeDivisionesList] = useState([])
    const [provinciasList, setProvinciasList] = useState([])
    const [municipiosList, setMunicipiosList] = useState([])

    const [provincia, setProvincia] = useState('')

    const [ultimoPerfilEmpresarial, setUltimoPerfilEmpresarial] = useState();

    const handleClose = () => {
        setOpenDialogError(false);
    }

    useEffect(() => {
        isLogged &&
            getData(user).then(
                (data) => {
                    setComunidadesAutonomasList(data.comunidadesAutonomas)
                    setVolumenNegocioList(data.volumenNegocio)
                    setCnaeList(data.cnaeSectores)
                    if (data.ultimoPerfilempresarial) {
                        setUltimoPerfilEmpresarial(data.ultimoPerfilempresarial);
                        setValue("volumenNegocio", data.volumenNegocio.filter(s => s.id_volumen_negocio === data.ultimoPerfilempresarial?.id_volumen_negocio)[0]);
                        setValue("comunidadAutonoma", data.comunidadesAutonomas.filter(s => s.id_comunidad === data.ultimoPerfilempresarial?.id_comunidad)[0]);
                        var listaProvincias = data.comunidadesAutonomas.filter(s => s.id_comunidad === data.ultimoPerfilempresarial?.id_comunidad)[0].provincias;
                        setProvinciasList(listaProvincias);
                        setValue("provincia", listaProvincias.filter(s => s.id_provincia === data.ultimoPerfilempresarial?.id_provincia)[0]);
                        setProvincia(listaProvincias.filter(s => s.id_provincia === data.ultimoPerfilempresarial?.id_provincia)[0])

                        setValue("cnaePrincipal", data.cnaeSectores.filter(s => s.id_CNAE_sector === data.ultimoPerfilempresarial.id_CNAE_sector)[0]);
                        var listaCnaesDivisiones = data.cnaeSectores.filter(s => s.id_CNAE_sector === data.ultimoPerfilempresarial.id_CNAE_sector)[0]?.divisiones;
                        setCnaeDivisionesList(listaCnaesDivisiones);
                        setValue("cnaeDivisiones", listaCnaesDivisiones.filter(s => s.id_CNAE_division === data.ultimoPerfilempresarial.id_CNAE_division)[0]);
                        setValue("nif", data.ultimoPerfilempresarial.nif);
                        setValue("razonSocialNombre", data.ultimoPerfilempresarial.razon_social);
                    }
                },
                (promiseError) => {
                    console.error("Error: " + promiseError)
                }
            );


    }, [user]);

    useEffect(() => {
        if (provincia?.id_provincia) {
            getMunicipios(provincia.id_provincia).then(
                (data) => {
                    setMunicipiosList(data)
                    ultimoPerfilEmpresarial && setValue("municipio", data.filter(s => s.id_municipio === ultimoPerfilEmpresarial.id_municipio)[0]);
                },
                (promiseError) => {
                    console.error("Error: " + promiseError)
                }
            );
        }
    }, [provincia])

    const Guardar = (data, event) => {
        let cifValidated = false
        const {
            nif,
            razonSocialNombre,
            volumenNegocio,
            cnaePrincipal,
            cnaeDivisiones,
            comunidadAutonoma,
            provincia,
            municipio
        } = data;

        if (areFieldsDisabled) {
            nuevoConPerfilEmpresarial(
                user
            ).then(x => navigate("/seleccionar-modo-cuestionario")).catch(y => console.log(y))
        } else {
            if (isValidDNI(nif)) {
                cifValidated = true
            }

            if (isValidCIF(nif)) {
                cifValidated = true
            }
            if (!cifValidated) {
                setOpenDialogError(true)
                event.preventDefault()
            } else {
                nuevoConPerfilEmpresarial(
                    user,
                    nif,
                    razonSocialNombre,
                    volumenNegocio,
                    cnaePrincipal,
                    cnaeDivisiones,
                    comunidadAutonoma,
                    provincia,
                    municipio
                ).then(x => navigate("/seleccionar-modo-cuestionario")).catch(y => console.log(y))
            }
        }
    }
    
    const handleChangeComunidadAutonoma = (value) => {
        setValue("comunidadAutonoma", value);
        setValue("provincia", null);
        setValue("municipio", null);

        setProvinciasList(value.provincias)
    }

    const handleChangeProvincia = (value) => {
        setProvincia(value)
    }

    const handleChangeCnaePrincipal = (value) => {
        setValue("cnaePrincipal", value);
        setValue("cnaeDivisiones", null);
        setCnaeDivisionesList(value.divisiones)
    }

    const handleChangeMunicipio = (value) => {
        setValue("municipio", value);
    }
    const handleChangeCnaeDivision = (value) => {
        setValue("cnaeDivisiones", value);
    }
    const handleChangeVolumenNegocio = (value) => {
        setValue("volumenNegocio", value);
    }

    return (
        <Stack>
            <Typography variant="h1">{t('crearPerfilEmpresarial.titulo')}</Typography>
            <Box className='textCard'>
                <form onSubmit={handleSubmit(Guardar)}>
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >
                        <Box>
                            <Typography variant="parrafo" color="primary" > {Parser(t('crearPerfilEmpresarial.disclaimer'))} </Typography>
                        </Box>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <TextFieldRequired
                                    control={control}
                                    label={t('crearPerfilEmpresarial.cif')}
                                    name="nif"
                                    disabled={areFieldsDisabled}
                                    sx={{ width: '100%' }}
                                    required={!areFieldsDisabled}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <TextFieldRequired
                                    control={control}
                                    label={t('crearPerfilEmpresarial.nombre')}
                                    name="razonSocialNombre"
                                    disabled={areFieldsDisabled}
                                    sx={{ width: '100%' }}
                                    required={!areFieldsDisabled}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="volumenNegocio"
                                    dataList={volumenNegocioList}
                                    disabled={areFieldsDisabled}
                                    onChangeHanddle={handleChangeVolumenNegocio}
                                    optionLabel={(catEmp) => catEmp.texto}
                                    labelText={t('crearPerfilEmpresarial.volumenNegocio')}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                    value={volumenNegocioList.filter(s => s.id_volumen_negocio == ultimoPerfilEmpresarial?.id_volumen_negocio)[0]?.texto}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                        </Stack>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="left"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="comunidadAutonoma"
                                    dataList={comunidadesAutonomasList}
                                    optionLabel={ca => ca.nombre_comunidad}
                                    labelText={t('crearPerfilEmpresarial.comunidadAutonoma')}
                                    onChangeHanddle={handleChangeComunidadAutonoma}
                                    disabled={areFieldsDisabled}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                    defaultValue={ultimoPerfilEmpresarial ? ultimoPerfilEmpresarial.comunidadAutonoma : null}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="provincia"
                                    dataList={provinciasList}
                                    optionLabel={co => co.nombre_provincia}
                                    labelText={t('crearPerfilEmpresarial.provincia')}
                                    onChangeHanddle={handleChangeProvincia}
                                    disabled={areFieldsDisabled || !selectedComunidad} // Deshabilita si no se ha seleccionado una comunidad
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                    defaultValue={ultimoPerfilEmpresarial ? ultimoPerfilEmpresarial.provincia : null}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="municipio"
                                    dataList={municipiosList}
                                    onChangeHanddle={handleChangeMunicipio}
                                    optionLabel={mu => mu.nombre_municipio}
                                    labelText={t('crearPerfilEmpresarial.municipio')}
                                    disabled={areFieldsDisabled || !selectedProvincia} // Deshabilita si no se ha seleccionado una Provincia
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                    defaultValue={ultimoPerfilEmpresarial ? ultimoPerfilEmpresarial.municipio : null}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                        </Stack>


                        <Box sx={{ width: '100%', textAlign: 'left' }}>
                            <Typography color="primary" > {t('crearPerfilEmpresarial.principalCNAE')} </Typography>
                        </Box>
                        <Stack
                            direction={{ xs: 'column', md: 'row' }}
                            justifyContent="left"
                            alignItems="center"
                            spacing={2}
                            sx={{ width: '100%' }}
                        >
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="cnaePrincipal"
                                    dataList={cnaeList}
                                    optionLabel={cnae => cnae.texto_sector}
                                    labelText={t('crearPerfilEmpresarial.cnaePrincipal')}
                                    onChangeHanddle={handleChangeCnaePrincipal}
                                    disabled={areFieldsDisabled}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                    defaultValue={ultimoPerfilEmpresarial ? ultimoPerfilEmpresarial.cNAESector : null}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <AutocompleteSearchRequired
                                    control={control}
                                    name="cnaeDivisiones"
                                    dataList={cnaeDivisionesList}
                                    optionLabel={cnaeDivisiones => cnaeDivisiones.division_texto}
                                    labelText={t('crearPerfilEmpresarial.divisiones')}
                                    onChangeHanddle={handleChangeCnaeDivision}
                                    disabled={areFieldsDisabled || !selectedCnaePrincipal}
                                    required={!areFieldsDisabled}
                                    setValue={setValue}
                                    defaultValue={ultimoPerfilEmpresarial ? ultimoPerfilEmpresarial.cNAEDivision : null}
                                    isEmpresaPrueba={areFieldsDisabled}
                                />
                            </Box>
                        </Stack>
                        <Box>
                            <Button variant='contained' type="submit" >
                                {t('crearPerfilEmpresarial.guardar')}
                            </Button>
                        </Box>
                    </Stack>

                </form>
                <ErrorMessage showDialogError={openDialogError} errorDialogTitle={t('crearPerfilEmpresarial.errorNIF')} errorType={t('crearPerfilEmpresarial.mensajeErrorNIF')} handleClose={handleClose} />

            </Box>
        </Stack>
    );
}
